<template>
  <nav class="entity-links" aria-label="Sources">
    <ul class="entity-links__list">
      <li
        v-for="{ url, title, icon } in linksWithIcons"
        :key="url"
        class="entity-links__item"
        @click="$emit('link-click', title)"
      >
        <ELinkBubble
          :href="url"
          :target="linkTarget"
          color="result"
          :size="isDesktopUp ? 'm' : 's'"
          class="entity-links__link"
          :data-test-id="`entity-links-icon-${icon}`"
          rel="noopener"
        >
          <!-- TODO: maybe use EIcon and integrate local icon assets there -->
          <component
            :is="`e-${icon}`"
            class="entity-links__icon"
            :data-test-id="`entity-links-icon-${icon.toLowerCase()}`"
          />
          {{ title }}
        </ELinkBubble>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import ELinkBubble from '~~/common/vue/components/link-bubble';
import screen from '~~/common/vue/mixins/screen';

const linkProperties = ['url', 'title'];
const validateLink = (link) => linkProperties.every((property) => !!link[property]);
const components = {
  EBloomberg: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "bloomberg" */
    '~/assets/img/bloomberg.svg'
  ),
  EFacebook: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "facebook" */
    '~/assets/img/facebook.svg'
  ),
  EImdb: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "imdb" */
    '~/assets/img/imdb.svg'
  ),
  EInstagram: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "instagram" */
    '~/assets/img/instagram.svg'
  ),
  ELinkedin: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "linkedin" */
    '~/assets/img/linkedin.svg'
  ),
  ETripadvisor: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "tripadvisor" */
    '~/assets/img/tripadvisor.svg'
  ),
  ETwitter: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "twitter" */
    '~/assets/img/twitter.svg'
  ),
  EWebsite: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "website" */
    '~/assets/img/website.svg'
  ),
  EWikipedia: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "wikipedia" */
    '~/assets/img/wikipedia.svg'
  ),
  EYoutube: async () => import(
    /* webpackPrefetch: true */
    /* webpackChunkName: "youtube" */
    '~/assets/img/youtube.svg'
  ),
};
const icons = Object.keys(components).map((key) => key.slice(1).toLowerCase());

export default {
  components: {
    ...components,
    ELinkBubble,
  },
  mixins: [screen()],
  props: {
    links: {
      type: Array,
      default: () => [],
      validator: (value) => Array.isArray(value) && value.every(validateLink),
    },
  },
  computed: {
    ...mapGetters('user', ['linkTarget']),
    linksWithIcons() {
      return this.links.map((link) => {
        const icon = icons.find((icn) => link.title?.toLowerCase().includes(icn)) ?? 'website';
        return { ...link, icon };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.entity-links__list {
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  // doesn't work in Safari 13
  // but we accept this because it makes the layout much simpler
  gap: $space-1s;
  padding: 0;
  margin: 0;
  white-space: nowrap;
}

.entity-links__icon {
  color: var(--color-decorative-icon);
  margin-right: $space-1s;
  height: $icon-size-s;
  width: $icon-size-s;

  @include desktop {
    height: $icon-size-m;
    width: $icon-size-m;
  }
}
</style>
